import React, { useRef, useState, useEffect } from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function InnovativeSolutionsForEvolvingNeeds() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  const [mousePosition, setMousePosition] = useState({
    x: 0,
    y: 0
  });
  const buttonRef = useRef<HTMLDivElement>(null);
  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!buttonRef.current) return;
    const {
      left,
      top,
      width,
      height
    } = buttonRef.current.getBoundingClientRect();
    const x = e.clientX - (left + width / 2);
    const y = e.clientY - (top + height / 2);
    setMousePosition({
      x: x * 0.2,
      y: y * 0.2
    });
  };
  const handleMouseLeave = () => {
    setMousePosition({
      x: 0,
      y: 0
    });
  };
  return <section data-section-id="3318" id="the-advancement-edge" ref={sectionRef} className="relative min-h-screen w-full overflow-hidden bg-background flex flex-col justify-center py-20 md:py-32">
      {}
      <div className="absolute inset-0 z-0 opacity-40 pointer-events-none bg-gradient-to-b from-transparent via-transparent to-background">
        <div className="absolute top-[-10%] left-[-5%] w-[70%] h-[70%] rounded-full bg-primary/20 blur-[120px] animate-[pulse_8s_ease-in-out_infinite]" />
        <div className="absolute bottom-[-10%] right-[-5%] w-[60%] h-[60%] rounded-full bg-primary/10 blur-[150px] animate-[pulse_10s_ease-in-out_infinite_reverse]" />
        <div className="absolute top-[40%] left-[30%] w-[40%] h-[40%] rounded-full bg-primary/5 blur-[80px] animate-[bounce_12s_infinite]" />
      </div>

      <div className="container relative z-10 mx-auto px-6 md:px-12 flex flex-col h-full justify-between gap-16 md:gap-24">
        
        {}
        <div className={`transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <Badge variant="outline" className="mb-8 border-primary/40 text-primary tracking-[0.2em] px-4 py-1.5 text-xs uppercase font-mono font-bold bg-background/50 backdrop-blur-sm rounded-sm">
            PROVEN PATHWAY
          </Badge>
          
          <h1 className="font-sans font-black text-foreground leading-[0.85] tracking-tighter text-5xl sm:text-7xl md:text-8xl lg:text-[120px] max-w-6xl uppercase">
            YOUR PATH TO THE <br className="hidden md:block" />
            <span className="text-primary italic">NEXT LEVEL</span>
          </h1>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-end">
          
          {}
          <div className={`max-w-xl transition-all duration-1000 delay-200 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <p className="text-lg md:text-[22px] font-normal text-muted-foreground leading-relaxed uppercase tracking-tight">
              The definitive bridge between elite minor hockey and the ranks of Junior and College programs. Expert evaluation for serious athletes.
            </p>
          </div>

          {}
          <div className={`flex md:justify-end transition-all duration-1000 delay-400 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <div ref={buttonRef} onMouseMove={handleMouseMove} onMouseLeave={handleMouseLeave} style={{
            transform: `translate(${mousePosition.x}px, ${mousePosition.y}px)`,
            transition: "transform 0.1s ease-out"
          }} className="inline-block p-4">
              <Button asChild size="lg" className="h-20 px-12 text-xl rounded-sm shadow-[0_0_20px_rgba(218,11,11,0.3)] hover:shadow-[0_0_40px_rgba(218,11,11,0.5)] transition-all duration-300 bg-primary text-primary-foreground hover:bg-primary/90 hover:scale-105 uppercase font-bold tracking-wider">
                <Link to="/PlayerInquiryPage">
                  Start Your Evaluation
                  <ArrowRight className="ml-3 size-6" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}